import { render, staticRenderFns } from "./resumo.vue?vue&type=template&id=ee66d7fc"
import script from "./resumo.vue?vue&type=script&lang=js"
export * from "./resumo.vue?vue&type=script&lang=js"
import style0 from "./resumo.vue?vue&type=style&index=0&id=ee66d7fc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDivider } from 'vuetify/lib/components/VDivider';
installComponents(component, {VDivider})
